module.exports = __webpack_public_path__ + "img/empty_folder.c0525021.svg";